import React from "react";
import ReactDom from "react-dom";

export default class ImageCanvas extends React.Component {

    constructor(props) {
        super(props);

        this.state = { isLoading: true, url: props.url };

        this.onImageLoad = this.onImageLoad.bind(this);;
    }

    onImageLoad() {
        this.setState({ isLoading: false });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.url !== prevState.url) {
            return { isLoading: true, url: nextProps.url };
        }

        return null;
    }

    render() {
        const { url, isLoading } = this.state;
        const styles = { backgroundImage: `url(${url})` };

        return <div className="image-canvas">
            <div style={styles} className="image"></div>
            <img className="preloader" src={url} onLoad={this.onImageLoad} />
            {isLoading && <div className="image-canvas-overlay"></div>}
        </div>;
    }

}